export default __webpack_public_path__ + "static/media/members.f9ee6c30.svg";